export const defaultFormValues = {
  source_cart_id: "Woocommerce",
  target_cart_id: "Shopify",
  entities: {},
};

export const initialEstimatorState = {
  calculatedResult: null,
  entitiesPayload: null,
  insuranceOptions: [],
  selectedInsurance: null,
  migrationOptions: [],
  selectedOptionKeys: [],
  allOptionsConfig: null,
};

export const columns = [
  { dataIndex: "label", key: "label", width: "70%" },
  { dataIndex: "value", key: "value", width: "30%" },
];

export const ENTITY_DEFAULT_VALUES = {
  Products: 250,
  Customers: 150,
  Orders: 150,
};

export const ENTITY_PRESETS = {
  Products: [500, 5000, 10000],
  Customers: [1000, 5000, 10000],
  Orders: [500, 5000, 10000],
};

export const ENTITY_FIXED_PRICE_LABELS = {
  Blogs: "Included",
};

export const CALCULATION_DEBOUNCE_MS = 500;
